"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.getWebConfig = void 0;
var metrics_utils_1 = require("@snapchat/metrics-utils");
var WebAuthenticator_1 = __importDefault(require("../auth/WebAuthenticator"));
var WebMetricCollector_1 = __importDefault(require("../collector/WebMetricCollector"));
var getWebConfig = function (collectorOptions) { return ({
    protocol: 'https:',
    host: 'gcp.api.snapchat.com',
    path: '/web/metrics',
    headers: {
        'Content-Type': 'application/x-protobuf'
    },
    authType: metrics_utils_1.AuthType.WebAttestation,
    authenticator: new WebAuthenticator_1["default"](),
    collector: new WebMetricCollector_1["default"](collectorOptions)
}); };
exports.getWebConfig = getWebConfig;
exports["default"] = exports.getWebConfig;
//# sourceMappingURL=web.js.map